import test from './src/test.vue';
export default Vue => {
    Vue.component(test.name, test);
};